export default __webpack_public_path__ + "static/media/ecom-cart.4aac2e3f.gif";